<template>
    <div>
        <div class="header-return">
            <el-row :gutter="20">
                <el-col :span="2">
                    <el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>
                </el-col>
                <el-col :span="20" :offset="2">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap"
                             :size="GCONFIG.styleElFormSize">
                        <el-form-item label="名称">
                            <el-input v-model="formInline.taskName" placeholder="输入名称查询"></el-input>
                        </el-form-item>
                        <el-form-item label="发送时间">
                            <el-date-picker
                                    v-model="queryDate"
                                    type="daterange"
                                    align="right"
                                    unlink-panels
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    format="yyyy 年 MM 月 dd 日"
                                    value-format="yyyy-MM-dd"
                                    :picker-options="pickerOptions">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="getList">查询</el-button>
                            <el-button type="primary" size="mini" @click="add()" class="header-btn">新建</el-button>
                            <el-button type="primary" size="mini" @click="handleEdit({id:0})" class="header-btn">新建2</el-button>
                        </el-form-item>
                    </el-form>
                </el-col>
            </el-row>
        </div>
        <el-table :data="list" stripe border center :size="GCONFIG.styleTableSize">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column label="标识" prop="id" width="100"></el-table-column>
            <el-table-column label="任务名称" prop="taskName" width="190"></el-table-column>
            <el-table-column label="描述" prop="taskDesc" width="230"></el-table-column>
            <el-table-column label="开始时间" prop="beginTime" width="130">
                <template slot-scope="scope">
                    <span>{{formatDate(scope.row.beginTime)}}</span>
                </template>
            </el-table-column>
            <el-table-column label="结束时间" prop="endTime" width="130">
                <template slot-scope="scope">
                    <span>{{formatDate(scope.row.endTime)}}</span>
                </template>
            </el-table-column>
            <el-table-column label="组名称" prop="groupName" width="190"></el-table-column>
            <el-table-column label="活动名称" prop="activeName" width="190"></el-table-column>
            <el-table-column label="状态" prop="taskStatusName" width="60"></el-table-column>
            <el-table-column label="消息内容" prop="content" width="230"></el-table-column>
            <el-table-column label="发送时间" prop="execTime" width="130">
                <template slot-scope="scope">
                    <span>{{formatDate(scope.row.execTime)}}</span>
                </template>
            </el-table-column>
            <el-table-column label="下次执行时间" prop="nextTime" width="130">
                <template slot-scope="scope">
                    <span>{{formatDate(scope.row.nextTime)}}</span>
                </template>
            </el-table-column>
            <el-table-column label="消息类型" prop="messageTypeName" width="60"></el-table-column>
            <el-table-column label="操作" fixed="right" width="320">
                <template slot-scope="scope">
                    <el-button-group>
<!--                        <el-button type="success" size="mini"  v-show="scope.row.taskStatus==0" @click="preview(scope.row)">预览</el-button>-->
                        <el-button type="success" size="mini" @click="preview(scope.row)">预览</el-button>
                        <el-button type="primary" v-show="scope.row.taskStatus==0||scope.row.taskStatus==1||scope.row.taskStatus==3||scope.row.taskStatus==4"  size="mini" @click="edit(scope.row)">编辑</el-button>
                        <el-button type="primary" v-show="scope.row.taskStatus==0||scope.row.taskStatus==1||scope.row.taskStatus==3||scope.row.taskStatus==4"  size="mini" @click="handleEdit(scope.row)">编辑2</el-button>
                        <el-button type="success" v-show="scope.row.taskStatus==1"  size="mini" @click="send(scope.row)">立即发送</el-button>

                        <el-button type="danger" v-show="scope.row.taskStatus==0||scope.row.taskStatus==3||scope.row.taskStatus==4"  size="mini" @click="handleDel(scope.row)">删除</el-button>
                        <el-button type="primary" v-show="scope.row.taskStatus==1"  size="mini" @click="cancel(scope.row)">撤销</el-button>
                    </el-button-group>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-wrap">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="recordsTotal">
            </el-pagination>
        </div>
        <el-dialog title="任务" :visible.sync="showDialog">
            <el-form :model="model" label-width="120px">

                <el-form-item label="任务名称" prop="taskName">
                    <el-input v-model="model.taskName" placeholder="任务名称"></el-input>
                    <span style="color: red">*</span>
                </el-form-item>
                <el-form-item label="描述">
                    <el-input v-model="model.taskDesc" placeholder="描述"></el-input>
                </el-form-item>
                <el-form-item label="用户组">
                    <el-select v-model="model.groupId" filterable clearable  placeholder="用户组">
                        <el-option v-for="item in userGroupList"
                                   :key="item.id"
                                   :label="item.userGroupName"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                    <span style="color: red">*</span>
                </el-form-item>
                <el-form-item label="任务执行频率">
                    <el-select v-model="model.periodType" @change="onPeriodType" clearable  placeholder="任务执行频率" >
                        <el-option v-for="item in periodTypeList"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                    <span style="color: red">*</span>
                </el-form-item>
                <el-form-item label="发送时间">
                    <el-date-picker
                            v-model=model.execTime
                            type="datetime"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择日期">
                    </el-date-picker>
                    <span style="color: red">*</span>
                </el-form-item>
                <el-form-item label="开始日期"  v-show="showStartTime">
                    <el-date-picker
                            v-model=model.beginTime
                            type="datetime"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="结束日期"  v-show="showStartTime">
                    <el-date-picker
                            v-model=model.endTime
                            type="datetime"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="活动">
                    <el-select v-model="model.activeNo" filterable clearable  placeholder="活动">
                        <el-option v-for="item in activeList"
                                   :key="item.activeNo"
                                   :label="item.activeName"
                                   :value="item.activeNo">
                        </el-option>
                    </el-select>
                    <span style="color: red">需要给用户发送优惠券时请选择活动，并在活动上绑定优惠券</span>
                </el-form-item>
                <el-form-item label="消息类型">
                    <el-select v-model="model.messageType" @change="onMessageType" clearable  placeholder="消息类型">
                        <el-option v-for="item in messageTypeList"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                    <span style="color: red">*</span>
                </el-form-item>
                <el-form-item label="消息内容" v-show="showSmsTemplate">
                    <el-select v-model="model.templateId" clearable  placeholder="消息内容">
                        <el-option v-for="item in templateList"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                    <span style="color: red">请选择消息内容,短信内容在基础服务平台应用管理里配置，客服消息在微信关键字里配置,模板消息在微信模板消息里配置内容</span>
                </el-form-item>
                <el-form-item label="消息模板" v-show="showTemplate">
                    <el-select v-model="model.templateId" filterable clearable  placeholder="消息模板">
                        <el-option v-for="item in wechatTemplateList"
                                   :key="item.messageId"
                                   :label="item.messageName"
                                   :value="item.messageId">
                        </el-option>
                    </el-select>
                    <span style="color: red">*</span>
                </el-form-item>
                <el-form-item label="微信Action" v-show="showAction">
                    <el-select v-model="model.actionId" filterable clearable  placeholder="消息模板">
                        <el-option v-for="item in actions"
                                   :key="item.key"
                                   :label="item.name"
                                   :value="item.key">
                        </el-option>
                    </el-select>
                    <span style="color: red">*</span>
                </el-form-item>
              <el-form-item label="发送方式">
                <el-select v-model="model.taskPushType" clearable  placeholder="消息内容">
                  <el-option v-for="item in pushTypeList"
                             :key="item.key"
                             :label="item.name"
                             :value="item.key">
                  </el-option>
                </el-select>
              </el-form-item>
                <el-form-item label="客服消息关键字" v-show="showKeyworld">
                    <el-select v-model="model.templateId" filterable clearable  placeholder="客服消息关键字">
                        <el-option v-for="item in keyworldList"
                                   :key="item.id"
                                   :label="item.keyword"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                    <span style="color: red">*</span>
                </el-form-item>
                <el-form-item label="消息提醒类型">
                    <el-select v-model="model.taskType" clearable  placeholder="消息提醒类型">
                        <el-option v-for="item in messageNoticeList"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                    <span style="color: red">*</span>
                </el-form-item>
                <el-form-item label="平台" v-show="platformShow">
                    <el-select v-model="model.platformId"  placeholder="平台" :disabled="platformDisabled">
                        <el-option v-for="item in platformList"
                                   :key="item.platformId"
                                   :label="item.platformName"
                                   :value="item.platformId">
                        </el-option>
                    </el-select>
                    <span style="color: red">*</span>
                </el-form-item>
                <el-form-item>
                    <el-button @click="showDialog = false">取 消</el-button>
                    <el-button type="primary" @click="save" class="header-btn">
                        保存
                    </el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <el-dialog title="预览" :visible.sync="previewShow">
            <el-form  label-width="120px">
                <el-form-item label="预览帐号" prop="name">
                    <el-input v-model="account" placeholder="预览帐号 发送短信填写手机号,发送客服消息或模板消息填写customerId "></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button-group>
                        <el-button @click="previewShow = false">取 消</el-button>
                        <el-button type="primary" @click="sendPreview()" class="header-btn">
                            预览
                        </el-button>
                        <el-button type="primary" v-show="canAudit" @click="audit()" class="header-btn">
                            审核
                        </el-button>
                    </el-button-group>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>
<script>
    //导入 HTTP请求方法
    import {
        getTaskListApi, saveTaskApi,auditTaskApi,getTaskParaListApi,getActiveForOptionListApi,previewApi,deleteTaskApi,cancelApi,getKeywordsOption,listTemplateMessage,pullUserToRedisByTaskIdApi,
        getAllPlatFormList,getAction
    } from '../../api/api';
    export default {
        data() {
            return {
                showDialog: false,
                list: [],
                queryDate:[],
                actions:[],
                canAudit:false,
                pickerOptions: {
                    shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                activeList:[],
                userGroupList:[],
                templateList:[],
                pushTypeList:[],
                platformList:[],
                platformDisabled:false,
                platformShow:false,
                messageTypeList:[{id:1,name:'短信'},{id:2,name:'微信模板消息'},{id:3,name:'微信客服消息'},{id:4,name:'邮件'},{id:5,name:'微信商城Action'}],
                periodTypeList:[{id:0,name:'仅一次'},{id:1,name:'每天执行一次'},{id:7,name:'每周执行一次'}],
                messageNoticeList:[{id:1,name:'营销类'},{id:2,name:'通知类'}],
                recordsTotal:0,
                formInline: {
                    currentPage: 1,
                    pageSize: 10,
                    taskName:'',
                    beginTime:'',
                    endTime:''
                },
                formInline1: {
                    platformGroupId: 1000,
                    currentPage: 1,
                    pageSize: 25,
                    recordsTotal: 0,
                },
                model: {
                    id:'' ,
                    taskName: '',
                    taskDesc: '',
                    beginTime: '',
                    endTime: '',
                    groupId: 0,
                    activeNo: '',
                    taskStatus: 0,
                    templateId: 0,
                    actionId: '',
                    taskPushType:'',
                    execTime: '',
                    periodType: 0,
                    messageType: 1,
                    rate: 100,
                    taskType:1,
                    platformId:0
                },
                account:'',//消息预览帐号
                loading: true,
                previewShow:false,//显示预览
                showDialog:false,
                keyworldList:[],
                wechatTemplateList:[],
                showKeyworld:false,
                showTemplate:false,
                showSmsTemplate:true,
                showStartTime:false,
                showAction:false,
                rules: {
                    name: [
                        {required: true, message: '应用名称必填', trigger: 'blur'}
                    ],
                    prefix: [
                        {required: true, message: '应用短信后缀必填', trigger: 'blur'}
                    ],
                    channelParams: [
                        {required: true, message: '第三方调用授权参数', trigger: 'blur'}
                    ]
                }
            }
        },
        created() {

        },
        //挂载时候执行
        mounted(){
            this.getList();
            this.getActiveList();
            this.getEnableKeyworldList();
            this.getTemplateList();
            this.getPlatformList();
            this.getActions();
        },
        methods: {
            getList(){
                if(this.queryDate!=''&&this.queryDate!=null){
                    this.formInline.beginTime=this.queryDate[0];
                    this.formInline.endTime=this.queryDate[1];
                }else {
                    this.formInline.beginTime='';
                    this.formInline.endTime='';
                }
                //查询模板列表
                getTaskListApi(this.formInline).then((res) => {
                    this.canAudit=false;
                    console.log(res);
                    if (res.data.success) {
                        this.recordsTotal = res.data.value.total;
                        this.list = res.data.value.list;
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            getPlatformList() {
                getAllPlatFormList(this.formInline1).then((res) => {
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '查询成功',
                            type: 'success'
                        });
                        this.platformList = res.data.value.list;
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            getActions() {
              getAction().then((res) => {
                    if (res.data.status == 200) {
                        this.actions = res.data.value;
                    } else {
                        this.$message({
                            showClose: true,
                            message: '获取Action列表失败',
                            type: 'error'
                        });
                    }
                })
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getList()
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getList()
            },
            add(){
                this.model = {
                    id:'' ,
                    taskName: '',
                    taskDesc: '',
                    beginTime: '',
                    endTime: '',
                    groupId: 0,
                    activeNo: '',
                    taskStatus: 0,
                    templateId: 0,
                    execTime: '',
                    periodType: 0,
                    messageType: 1,
                    rate: 100,
                    taskType:1,
                    platformId:0
                };
                this.platformDisabled=false;
                this.showDialog = true;
                this.getTaskParaList();
            },
            edit(row){
                this.getTaskParaList();
                this.selectRow(row);
                this.showDialog = true;
                this.platformDisabled=true;
                this.onMessageType(row.messageType);
            },
            selectRow(row){
                this.model = {
                    id: row.id,
                    taskName: row.taskName,
                    taskDesc: row.taskDesc,
                    beginTime: this.formatDate(row.beginTime),
                    endTime: this.formatDate(row.endTime),
                    groupId: row.groupId,
                    activeNo: row.activeNo,
                    taskStatus: row.taskStatus,
                    templateId: row.templateId,
                    execTime: this.formatDate(row.execTime),
                    periodType: row.periodType,
                    messageType: row.messageType,
                    rate: row.rate,
                    taskType:row.taskType,
                    platformId:row.platformId
                };
            },
            save(){
                //保存应用
                if(this.model.taskName==''){
                    this.$message({
                        message: '名称不能为空',
                        type: 'error'
                    });
                    return;
                }
                if(this.showStartTime){
                    if(this.model.beginTime==''){
                        this.$message({
                            message: '开始时间必填',
                            type: 'error'
                        });
                        return;
                    }
                    if(this.model.endTime==''){
                        this.$message({
                            message: '结束时间必填',
                            type: 'error'
                        });
                        return;
                    }
                }
                if(this.model.execTime==''){
                    this.$message({
                        message: '任务执行时间必填',
                        type: 'error'
                    });
                    return;
                }
                if(this.model.groupId==''){
                    this.$message({
                        message: '用户组必选',
                        type: 'error'
                    });
                    return;
                }
                if(this.model.templateId==''){
                    this.$message({
                        message: '消息内容必选',
                        type: 'error'
                    });
                    return;
                }
                this.loading=true;
                saveTaskApi(this.model).then((res) => {
                    console.log(res);
                    this.loading=false;
                    if (res.data.success) {
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                        this.getList();
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                    this.showDialog = false;
                });
            },
            handleDel(row){
                this.$confirm('删除不可撤销, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteTaskApi({taskId:row.id}).then((res) => {
                        if (res.data.success) {
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.getList();
                        } else {
                            this.$message({
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    });
                });
            },
            getTaskParaList(){
                getTaskParaListApi().then((res) => {
                    if (res.data.success) {
                        this.userGroupList=res.data.value.groupList;
                        this.templateList=res.data.value.templateList;
                        this.pushTypeList = res.data.value.pushTypeList;
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                    //this.showDialog = false;
                });
            },
            getActiveList(){
                //保存应用
                getActiveForOptionListApi().then((res) => {
                    if (res.data.success) {
                        this.activeList=res.data.value;
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                    this.showDialog = false;
                });
            },
            preview(row){
                this.selectRow(row);
                this.previewShow=true;
            },
            sendPreview(){
                //消息推送预览
                //设置预览
                this.loading=true;
                if(this.account==''){
                    this.$message({
                        message: '帐号不能为空',
                        type: 'error'
                    });
                    return;
                }else {
                    previewApi({taskId:this.model.id,account:this.account}).then((res) => {
                        this.loading=false;
                        if (res.data.success) {
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.canAudit=true;
                        } else {
                            this.$message({
                                message: res.data.message,
                                type: 'error'
                            });
                        }

                    });
                }
            },
            auditTask(row){
                this.selectRow(row);
                this.audit();
            },
            audit(){
                //审核
                if(this.model.taskStatus==0){
                    this.loading=true;
                    auditTaskApi({taskId:this.model.id}).then((res) => {
                        this.canAudit=false;
                        this.loading=false;
                        console.log(res);
                        if (res.data.success) {
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.getList();
                        } else {
                            this.$message({
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                        this.previewShow = false;
                        //this.previewShow = false;
                    });
                }else {
                    this.$message({
                        message: '该任务状态不可以审核',
                        type: 'error'
                    });
                }
            },
            cancel(row){
                //任务撤销
                this.selectRow(row);
                this.loading=true;
                cancelApi({taskId:this.model.id}).then((res) => {
                    console.log(res);
                    this.loading=false;
                    if (res.data.success) {
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                        this.getList();
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                    this.previewShow = false;
                });
            },
            send(row){
                this.$confirm('立即发送不可撤销, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.loading=true;
                    pullUserToRedisByTaskIdApi({taskId:row.id}).then((res) => {
                        this.canAudit=false;
                        this.loading=false;
                        console.log(res);
                        if (res.data.success) {
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.getList();
                        } else {
                            this.$message({
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                        this.previewShow = false;
                        //this.previewShow = false;
                    });
                })
            },
            formatDate(datetime) {
                var date = new Date(datetime);
                var year = date.getFullYear(),
                    month = ("0" + (date.getMonth() + 1)).slice(-2),
                    sdate = ("0" + date.getDate()).slice(-2),
                    hour = ("0" + date.getHours()).slice(-2),
                    minute = ("0" + date.getMinutes()).slice(-2),
                    second = ("0" + date.getSeconds()).slice(-2);
                // 拼接
                var result = year + "-"+ month +"-"+ sdate +" "+ hour +":"+ minute +":" + second;
                // 返回
                return result;
            },
            getEnableKeyworldList(){
                //关键字
                getKeywordsOption({platformId:1}).then((res) => {
                    this.keyworldList = res.data.filter(item => item.type=='text');
                    this.keyworldList.push({'id':0,'keyword':'无'});
                });
            },
            getTemplateList(){
                this.loading = true;
                listTemplateMessage({
                    platformId:1,
                    currentPage: 1,
                    pageSize: 150
                }).then((res) => {
                    this.loading = false;
                    this.wechatTemplateList = res.data.messageList.list.filter(item => item.platformId==1);
                })
            },
            onPeriodType(newValue){
                if(newValue ==0){
                    this.showStartTime=false;
                }else {
                    this.showStartTime=true;
                }
            },
            onMessageType(newValue) {
                if (newValue ==1) {
                    //短信
                    this.showKeyworld=false;
                    this.showTemplate=false;
                    this.showSmsTemplate=true;
                    this.platformShow=false;
                } else if(newValue ==2) {
                    //微信模板消息
                    this.showKeyworld=false;
                    this.showTemplate=true;
                    this.showSmsTemplate=false;
                    this.platformShow=true;
                }else if(newValue ==3) {
                    //微信模板客户消息
                    this.showKeyworld=true;
                    this.showTemplate=false;
                    this.showSmsTemplate=false;
                    this.platformShow=true;
                }else  if(newValue ==4){
                    //邮件
                    this.showKeyworld=false;
                    this.showTemplate=false;
                    this.showSmsTemplate=true;
                    this.platformShow=false;
                }else  if(newValue ==5){
                  //邮件
                  this.showKeyworld=false;
                  this.showTemplate=false;
                  this.showSmsTemplate=false;
                  this.platformShow=false;
                  this.showAction = true;
                }
            },
            handleEdit(row){
                this.$router.push({path:'/task/detail/:id',name: 'TaskEdit',params:{id:row.id},query:{taskId:row.id}})
                // this.$router.push({path:'/productlist/detail/:id',name: 'ProductDetail',params:{id:row.taskId},query:{proId:row.taskId,picType:'',picFrom:'noReturn'}})
            },
            returnHistory(){
                window.history.back()
            }
        }
    }
</script>
<style>
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
</style>


// WEBPACK FOOTER //
// src/views/sms/task.vue